import { useReducer } from "react";
import {
    clearLocalStorage,
    revokeStoredSession,
    storeSessionToken,
} from "../../services/auth/auth.service";
import AuthContext from "./AuthContext";
import { ACTIONS } from "./Constants";
import { resolveGroupRole } from "../../utils/utils";

const AuthProvider = (props: any) => {
    const [state, dispatch] = useReducer(
        (prevState: any, action: any) => {
            switch (action.type) {
                case ACTIONS.SET_TOKEN:
                    return {
                        ...prevState,
                        token: action.token,
                        isLoading: false,
                    };

                case ACTIONS.LOGIN:
                    storeSessionToken(action.token);
                    return {
                        ...prevState,
                        token: action.token,
                        isLoading: false,
                    };

                case ACTIONS.SET_USER:
                    let group_role = resolveGroupRole(action.user);

                    const userWithRole = {
                        ...action.user,
                        group_role,
                        students: prevState?.user?.students || [],
                    };

                    localStorage.setItem("user", JSON.stringify(userWithRole));

                    return {
                        ...prevState,
                        user: userWithRole,
                    };

                case ACTIONS.SET_EMAIL_STRIPE_CHECKOUT:
                    return {
                        ...prevState,
                        emailForStripeCheckout:
                            action.payload.emailForStripeCheckout,
                    };

                case ACTIONS.SET_STUDENTS_UNDER_USER:
                    return {
                        ...prevState,
                        user: { ...prevState.user, students: action.students },
                    };

                case ACTIONS.LOGOUT:
                    revokeStoredSession();
                    clearLocalStorage();
                    window.parent?.postMessage("AHA_WEB_APP_LOGOUT", "*");
                    (window as any).hsConversationsSettings = {
                        loadImmediately: false,
                    };
                    return {
                        ...prevState,
                        token: null,
                        isLoading: false,
                        user: null,
                        avoidGameSetting: true,
                    };

                case ACTIONS.SET_LOADING:
                    return {
                        ...prevState,
                        isLoading: action.isLoading,
                    };
                default:
                    throw new Error("Undefined action provided.");
            }
        },
        {
            user: null,
            isLoading: true,
            token: null,
            avoidGameSetting: false,
            triggerAdminLogout: false,
        }
    );

    return (
        <AuthContext.Provider value={{ state, dispatch }}>
            {props.children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;
